import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { ParticipantMarketType } from '@cds/betting-offer';
import { EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { FixtureParticipantPriceMap, HorsesRaceResultedViewModel, WinGameFixture, WinGameParticipant } from '@frontend/sports/racing/feature/models';

import { HorsesFixtureParticipantHelper } from '../../../horse-racing-shared/services/horses-fixture-participant-helper.service';
import { HorsesFixturePricingHelper } from '../../../horse-racing-shared/services/horses-fixture-pricing-helper.service';
import { HorsesFixtureSortingHelper } from '../../../horse-racing-shared/services/horses-fixture-sorting-helper.service';
import { ResultedDividentsCalculatorService } from '../../services/resulted-dividents-calculator.service';

@Component({
    selector: 'ms-horses-race-resulted',
    templateUrl: 'horses-race-resulted.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HorsesRaceResultedComponent implements OnChanges {
    @Input() fixture: WinGameFixture;
    prices: FixtureParticipantPriceMap = {};
    viewModel: HorsesRaceResultedViewModel;
    participantOptionGroups: { [id: string]: EventOption[] };
    optionGroups: EventOptionGroup[];
    isOptionBet: boolean;
    constructor(
        private horsesFixturePricingHelper: HorsesFixturePricingHelper,
        private horsesFixtureParticipantHelper: HorsesFixtureParticipantHelper,
        private resultedDividentsCalculatorService: ResultedDividentsCalculatorService,
        public sitecore: Sitecore,
        public horsesFixtureSortingHelper: HorsesFixtureSortingHelper,
    ) {}

    ngOnChanges(changes: ISimpleChanges<HorsesRaceResultedComponent>): void {
        if (changes.fixture && changes.fixture.currentValue) {
            this.isOptionBet = changes.fixture.currentValue.isOptionBet;
            this.setModel(changes.fixture.currentValue);
        }
    }

    private setModel(fixture: WinGameFixture): void {
        this.prices = this.horsesFixturePricingHelper.getPrices(fixture, ParticipantMarketType.Win);
        const dividends = this.resultedDividentsCalculatorService.getDividends(fixture);
        this.viewModel = {
            placed: this.horsesFixtureParticipantHelper.getPlacedParticipants(this.fixture),
            favorites: this.isOptionBet ? this.getOptionFavoutites() : this.getFavorite(),
            nonRunners: this.getNonRunners(),
            dividends,
            hasDividends: dividends.some((dividend) => dividend.available),
            hasSilks:
                this.fixture.participants.some((_) => !!_.timeformInfo?.silkUrl) ||
                this.horsesFixtureParticipantHelper.areSilksAvailable(this.fixture),
            participantOptionGroups: this.horsesFixtureParticipantHelper.buildWinParticipantOptionGroups(this.fixture),
        };
    }

    private getOptionFavoutites() {
        return this.horsesFixtureParticipantHelper.favouriteResultedOptionParticipants(this.fixture);
    }

    private getNonRunners(): WinGameParticipant[] {
        return this.horsesFixtureParticipantHelper.getNonRunnersList(this.fixture);
    }

    private getFavorite(): WinGameParticipant[] {
        return this.horsesFixtureParticipantHelper.getResultedFavourites(this.fixture);
    }
}
